import { Div } from '../../../base/components/native/div'
import { Img } from '../../../base/components/native/img'
import { CENTER, EASE, SHOW, WH } from '../../../base/helpers/style'
import ldb from '../../../base/lib/ldb'
import state from '../../../base/services/state'
import { Designs } from './designs'
import { StartAgainButton } from './start-again-button'
import { Waiting } from './waiting'

export const Preview = () => {
    const [, setDesign] = state.use('design')
    const base = Div()
    const title = Div('Choose the design you want to <b>continue</b> with')
    const designs = Designs()
    const startAgain = StartAgainButton()
    base.append(title, designs, startAgain)

    title.cssClass({
        marginBottom: '25px',
    })
    base.cssClass({
        ...CENTER,
        flexDirection: 'column',
        marginTop: '0',
        paddingTop: '40px',
        paddingBottom: '60px',
        backgroundColor: '#fff',
        width: '100%',
        textAlign: 'center',
        display: 'none',
        color: '#000',
        '@media (max-width: 768px)': {
            marginTop: '20px',
        }
    })
    startAgain.el.onclick = () => {
        base.emit('start-again')
        designs.empty()
    }

    let mode: string
    return Object.assign(base, {
        fill(urls: string[]) {
            designs.empty()
            urls.forEach((url: string) => {
                const img = Img(url, { width: 325, height: 325 })
                img.style({ borderRadius: '10px', margin: '5px', cursor: 'pointer' })
                designs.append(img)
                img.el.onclick = () => {
                    const rect = img.el.getBoundingClientRect()
                    const parentRect = base.el.getBoundingClientRect()
                    const scale = parentRect.width / rect.width
                    const imgCenterX = rect.left + rect.width / 2
                    const imgCenterY = rect.top + rect.height / 2
                    const centerX = parentRect.left + parentRect.width / 2
                    const centerY = parentRect.top + parentRect.height / 2
                    const x = (centerX - imgCenterX) * scale
                    const y = (centerY - imgCenterY) * scale
                    ldb.save('design-url'  , url)
                    setDesign( url )
                    base.emit('ready')
                }
            })
        },
        back() {
            mode = ''
            designs.style({
                transform: 'none',
            })
        },
        reset() {
            designs.style({
                ...EASE(.16),
                transform: 'scale(0)',
            })
            mode = ''
            setTimeout(() => {
                designs.style({
                    transform: 'scale(1)',
                })
                designs.empty()
            }, 1000)
        },

    })
}